import React from 'react';

export default function Footer() {
	return (
		<footer className="bg-color-primary-caramel small text-center ">
			<div className="container">
				&copy; 2024 Kam Chauhan | <a href="privacy-policy" className="color-primary-black">Privacy Policy</a>
			</div>
		</footer>
	);
}
